<template>
	<div class="quick-search-wrapper">
		<h1>{{ title }}</h1>
		<v-select 
			:filterable="false" 
			:options="results" 
			@search="onSearch" 
			@search:blur="clearSearchTerm"
			@option:selected="selectAndGoTo"
			:components="{
				Deselect: {
					render: createElement => createElement('span', 'x'),
				},
				OpenIndicator: {
					render: createElement => createElement('span', {class: {'toggle': true}}),
				}
			}">
			<template #header>
				<label for="quick-search" :class="[{
					'screen-reader-only': labelHidden
				}]">{{ $t('what_are_you_looking_for') }}</label>
			</template>
			<template #search="{ attributes, events }">
				<div id="quick-search-input-wrapper">
					<input
						ref="searchField"
						class="vs__search"
						id="quick-search"
						v-bind="attributes"
						@keyup="updateSearchTerm"
						v-on="events"
					>
					<svg aria-hidden="true" id="quick-search-icon" xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40">
						<defs>
						<filter id="h0uo60w1fa">
						<feColorMatrix in="SourceGraphic" values="0 0 0 0 0.200000 0 0 0 0 0.223529 0 0 0 0 0.254902 0 0 0 1.000000 0"/>
						</filter>
						</defs>
						<g fill="none" fill-rule="evenodd">
						<g>
						<g>
						<g transform="translate(-838 -134) translate(471 122) translate(367 12)">
						<circle cx="20" cy="20" r="19.5" stroke="#333941"/>
						<g filter="url(#h0uo60w1fa)" transform="translate(12 12)">
						<g>
						<path fill="#000" fill-rule="nonzero" d="M4.653 7.68c-.814.01-1.598-.303-2.18-.87-.583-.568-.916-1.344-.926-2.157v-.044C1.57 2.96 2.88 1.614 4.528 1.548c1.693-.046 3.103 1.289 3.149 2.982v.043l.001.04c.005.808-.31 1.585-.878 2.16-.568.575-1.34.901-2.148.906zm3.87-.465c.505-.774.772-1.678.769-2.602C9.274 2.05 7.186-.013 4.624-.001 2.062.011-.007 2.095-.001 4.657c.006 2.562 2.085 4.635 4.647 4.635C5.6 9.286 6.53 8.98 7.3 8.416l3.39 3.373c.168.166.438.166.605 0l.576-.574c.168-.166.17-.437.003-.605L8.522 7.215z" transform="translate(2 2)"/>
						</g>
						</g>
						</g>
						</g>
						</g>
						</g>
					</svg>
				</div>
			</template>
			<template slot="no-options">
				<span class="['no-result-text',
					{
						'hidden': searchTerm===''
					}
				]">{{ noResultsText }}</span>
			</template>
			<template slot="option" slot-scope="option">
				<div class="d-center">
					<a href="option.path">{{ option.title }}</a>
				</div>
			</template>
		</v-select>
	</div>
</template>

<script>
import vSelect from 'vue-select';
import Vue from 'vue';
Vue.component( 'v-select', vSelect );

export default {
	props: ['title', 'labelHidden'],
	data() {
		return {
			results: [],
			searchTerm: '',
			searchTimeout: null,
			loading: false,
		}
	},
	computed: {
		noResultsText() {
			return (this.searchTerm===''||this.loading) ? '' : this.$t('no_results_found')
		}
	},
	methods: {
		onSearch(term) {
			//if (this.loading) return false;
			this.results = [];
			if (term==='') return;
			window.clearTimeout(this.searchTimeout);
			this.searchTimeout = window.setTimeout(() => {
				this.loading = true;
				this.$http.post(window.dcSite.apiRoute + 'search', { 
					s: term,
					post_type: 'dc_article,page',
					posts_per_page: 5,
					quick_search: true
				}).then(response => {
					if (response.data.success) {
						if (response.data.posts) {
							this.results = response.data.posts
						} else {
							this.results = [];
						}
					}
					this.loading = false;
				});
			});
		},
		selectAndGoTo(option) {
			if (typeof option === 'undefined' || typeof option.path === 'undefined') return;
			this.$router.push({
				path: option.path,
			});
		},
		updateSearchTerm(e) {
			this.searchTerm = e.target.value;
			this.onSearch(e.target.value);
			console.log('search term: ' + e.target.value)
		},
		clearSearchTerm() {
			this.searchTerm = '';
		}
	},
	mounted() {
		this.$refs.searchField.focus()
	}
}
</script>

<style lang="scss">
  @import "../../styles/scss/global/quick-search";
</style>